export default class Language {

  static get codes() {
    return {
      taiwanese: ['zh-TW', 'zh-Hant', 'zh-Hant-TW', 'zh-Hant-MO', 'zh-Hant-HK'],
      arabic: ['ar'],
      bengali: ['bn'],
      chinese: ['zh'],
      danish: ['da'],
      finnish: ['fi'],
      dutch: ['nl'],
      english: ['en'],
      french: ['fr'],
      german: ['de'],
      greek: ['el'],
      hebrew: ['he'],
      hindi: ['hi'],
      hungarian: ['hu'],
      indonesian: ['id'],
      italian: ['it'],
      japanese: ['ja'],
      korean: ['ko'],
      norwegian: ['no', 'nn', 'nb'],
      polish: ['pl'],
      portuguese: ['pt'],
      romanian: ['ro'],
      russian: ['ru'],
      spanish: ['es'],
      swahili: ['sw'],
      swedish: ['sv'],
      thai: ['th'],
      turkish: ['tr'],
      ukrainian: ['uk'],
      vietnamese: ['vi']
    };
  }

  static get english() {
    return {
      hint: {
        auto: 'Auto',
        play: 'Play',
        pause: 'Pause',
        seek: 'Seek bar',
        enterFullscreen: 'Enter full screen',
        exitFullscreen: 'Exit full screen',
        rewind: 'Rewind',
        forward: 'Forward',
        sharing: 'Share',
        sharingLink: 'Link to video',
        sharingEmbedCode: 'Embed video',
        quality: 'Quality',
        volume: 'Volume',
        mute: 'Mute',
        unmute: 'Unmute',
        minus: 'Minus',
        plus: 'Plus',
        speed: 'Speed',
        captions: 'Closed captions',
        track: 'Track',
        transcript: 'Transcript',
        audio: 'Audio languages',
        chapters: 'Chapters',
        live: 'LIVE',
        close: 'Close',
        floating: 'Close',
        settings: 'Settings',
        back: 'Back',
        playlist: 'Playlist',
        next: 'Next',
        previous: 'Previous',
        related: 'Related',
        upNext: 'Up next',
        up: 'Up',
        down: 'Down',
        left: 'Left',
        right: 'Right',
        default: 'Default',
        off: 'Off',
        loop: 'Loop',
        theater: 'Theater mode',
        info: 'Information',
        keyboardShortcut: 'Keyboard shortcut'
      },
      fccCaptions: {
        fontColor: 'Font color',
        fontOpacity: 'Font opacity',
        fontSize: 'Font size',
        fontFamily: 'Font family',
        fontEdge: 'Font edge',
        backgroundColor: 'Background color',
        backgroundOpacity: 'Background opacity',
        windowColor: 'Window color',
        windowOpacity: 'Window opacity'
      },
      error: {
        error: 'Error',
        customErrorMessage: 'This content is currently unavailable',
        noSupportMessage: 'This content cannot be played on this device',
        noSupportInstallChrome: 'Using the latest version of Google Chrome may help to view this content'
      },
      ads: {
        controlBarCustomMessage: 'Ad',
        skipMessage: 'Skip ad',
        textForClickUIOnMobile: 'Learn more',
        adBlockDetectedMessage: 'AdBlock detected',
        adBlockMessageMessageExtended: 'Our website needs to show advertisement to our viewers - please allow ads on our website',
        adBlockDetectedButton: 'I have disabled AdBlock'
      }
    };
  }

  static get arabic() {
    return {
      hint: {
        auto: 'آلي',
        play: 'قراءة',
        pause: 'إيقاف',
        seek: 'بحث',
        enterFullscreen: 'أدخل ملء الشاشة',
        exitFullscreen: 'الخروج من الشاشة الكاملة',
        rewind: 'الترجيع',
        forward: 'إلى الأمام',
        sharing: 'تقاسم',
        sharingLink: 'الرابط نحو الفيديو',
        sharingEmbedCode: 'تضمين الفيديو',
        quality: 'الجودة',
        volume: 'الصوت',
        mute: 'كتم الصوت',
        unmute: 'إلغاء كتم الصوت',
        minus: 'أقلّ',
        plus: 'أكثر',
        speed: 'السرعة',
        captions: 'صور توضيحية',
        track: 'مسار',
        transcript: 'نسخة طبق الأصل',
        audio: 'لغات الصوت',
        chapters: 'الفصول',
        live: 'LIVE',
        close: 'اغلاق',
        floating: 'اغلاق',
        settings: 'إعدادات',
        back: 'عودة',
        playlist: 'Playlist',
        next: 'التالي',
        previous: 'السابق',
        related: 'ذات صلة',
        upNext: 'الموالي',
        up: 'فوق',
        down: 'أسفل',
        left: 'اليسار',
        right: 'حق',
        default: 'إفتراضي',
        off: 'انهاء',
        theater: 'وضع المسرح',
        loop: 'حلقة',
        info: 'معلومة',
        keyboardShortcut: 'اختصار لوحة المفاتيح'
      },
      fccCaptions: {
        fontColor: 'لون الخط',
        fontOpacity: 'تعتيم الخط',
        fontSize: 'حجم الخط',
        fontFamily: 'خط العائلة',
        fontEdge: 'حافة',
        backgroundColor: 'لون الخلفية',
        backgroundOpacity: 'تعتيم الخلفية',
        windowColor: 'لون النافذة',
        windowOpacity: 'تعتيم النافذة'
      },
      error: {
        error: 'خطأ',
        customErrorMessage: 'هذا المحتوى غير متوفّر حالياً',
        noSupportMessage: 'لا يمكن قراءة هذا المحتوى على هذا الجهاز',
        noSupportInstallChrome: 'قد يساعد استخدام أحدث إصدار من Google Chrome في عرض هذا المحتوى'
      },
      ads: {
        controlBarCustomMessage: 'اعلان',
        skipMessage: 'تخطّي الاعلان',
        textForClickUIOnMobile: 'معرفة المزيد',
        adBlockDetectedMessage: 'تم اكتشاف AdBlock',
        adBlockMessageMessageExtended: 'يحتاج موقعنا إلى عرض الإعلانات لمشاهدينا - يرجى السماح بالإعلان على موقعنا',
        adBlockDetectedButton: 'لقد قمت بتعطيل AdBlock'
      }
    };
  }

  static get bengali() {
    return {
      hint: {
        auto: 'স্বয়ংক্রিয়',
        play: 'খেলা',
        pause: 'বিরতি',
        seek: 'খোঁজ',
        enterFullscreen: 'পূর্ণ পর্দায়ই যান',
        exitFullscreen: 'পূর্ণ পর্দা সরান',
        rewind: 'রিওয়াইন্ড',
        forward: 'ফরোয়ার্ড',
        sharing: 'শেয়ার করুন',
        sharingLink: 'ভিডিও লিঙ্ক',
        sharingEmbedCode: 'ভিডিও এম্বেড করুন',
        quality: 'গুণমান',
        volume: 'আয়তন',
        mute: 'নিঃশব্দ',
        unmute: 'নিঃশব্দ',
        minus: 'বিয়োগ',
        plus: 'প্লাস',
        speed: 'গতি',
        captions: 'শিরোনাম বন্ধ কর',
        track: 'ট্র্যাক',
        transcript: 'প্রতিলিপি',
        audio: 'অডিও ভাষা',
        chapters: 'অধ্যায়',
        live: 'LIVE',
        close: 'বন্ধ',
        floating: 'বন্ধ',
        settings: 'সেটিংস',
        back: 'পেছনে',
        playlist: 'Playlist',
        next: 'পরবর্তী',
        previous: 'আগে',
        related: 'সম্পর্কিত',
        upNext: 'পরবর্তী আসছে',
        up: 'উপরে',
        down: 'নিচে',
        left: 'বাম',
        right: 'ঠিক',
        default: 'ডিফল্ট',
        off: 'বন্ধ',
        loop: 'লুপ',
        theater: 'থিয়েটার মোড',
        info: 'তথ্য',
        keyboardShortcut: 'কীবোর্ড শর্টকাট'
      },
      fccCaptions: {
        fontColor: 'ফন্টের রং',
        fontOpacity: 'হরফের অস্বচ্ছতা',
        fontSize: 'অক্ষরের আকার',
        fontFamily: 'ফন্ট পরিবার',
        fontEdge: 'হরফ প্রান্ত',
        backgroundColor: 'পেছনের রং',
        backgroundOpacity: 'পটভূমির অস্বচ্ছতা',
        windowColor: 'জানালার রঙ',
        windowOpacity: 'জানালার অস্বচ্ছতা'
      },
      error: {
        error: 'ত্রুটি',
        customErrorMessage: 'এই কন্টেন্ট বর্তমানে অনুপলব্ধ',
        noSupportMessage: 'এই কন্টেন্ট এই ডিভাইসে চালানো যাবে না',
        noSupportInstallChrome: 'Google Chrome-এর সর্বশেষ সংস্করণ ব্যবহার করা এই সামগ্রী দেখতে সাহায্য করতে পারে৷'
      },
      ads: {
        controlBarCustomMessage: 'বিজ্ঞাপন',
        skipMessage: 'বিজ্ঞাপন এড়িয়ে যান',
        textForClickUIOnMobile: 'আরও জানুন',
        adBlockDetectedMessage: 'AdBlock সনাক্ত করা হয়েছে',
        adBlockMessageMessageExtended: 'আমাদের ওয়েবসাইটকে আমাদের দর্শকদের বিজ্ঞাপন দেখানোর প্রয়োজন - দয়া করে আমাদের ওয়েবসাইটে বিজ্ঞাপনের অনুমতি দিন',
        adBlockDetectedButton: 'আমি AdBlock নিষ্ক্রিয় করেছি'
      }
    };
  }

  static get french() {
    return {
      hint: {
        auto: 'Auto',
        play: 'Lire',
        pause: 'Pause',
        seek: 'Barre de recherche',
        enterFullscreen: 'Passer en mode plein écran',
        exitFullscreen: 'Quitter le mode plein écran',
        rewind: 'Retour',
        forward: 'Avance',
        sharing: 'Partager',
        sharingLink: 'Lien vers la vidéo',
        sharingEmbedCode: 'Intégrer la vidéo',
        quality: 'Qualité',
        volume: 'Volume',
        mute: 'Désactiver le son',
        unmute: 'Activer le son',
        minus: 'Moins',
        plus: 'Plus',
        speed: 'Vitesse',
        captions: 'Sous-titres',
        track: 'Piste',
        transcript: 'Transcription',
        audio: 'Langues audio',
        chapters: 'Chapitres',
        live: 'DIRECT',
        close: 'Fermer',
        floating: 'Fermer',
        settings: 'Réglages',
        back: 'Retour',
        playlist: 'Playlist',
        next: 'Suivant',
        previous: 'Précédent',
        related: 'Médias liés',
        upNext: 'A suivre',
        up: 'Vers le haut',
        down: 'Vers le bas',
        left: 'Vers la gauche',
        right: 'Vers la droite',
        default: 'Remise à zéro',
        off: 'Désactivé',
        loop: 'En boucle',
        theater: 'Mode Cinéma',
        info: 'Information',
        keyboardShortcut: 'Raccourci clavier'
      },
      fccCaptions: {
        fontColor: 'Couleur de la police',
        fontOpacity: 'Transparence de la police',
        fontSize: 'Taille de la police',
        fontFamily: 'Type de la police',
        fontEdge: 'Contour de la police',
        backgroundColor: 'Couleur du fond',
        backgroundOpacity: 'Transparence du fond',
        windowColor: 'Couleur de la fenêtre',
        windowOpacity: 'Transparence de la fenêtre'
      },
      error: {
        error: 'Erreur',
        customErrorMessage: 'Ce contenu n\'est pas disponible pour le moment',
        noSupportMessage: 'Ce contenu ne peut être lu sur cet appareil',
        noSupportInstallChrome: 'Utiliser la dernière version de Google Chrome peut vous aider à lire ce contenu'
      },
      ads: {
        controlBarCustomMessage: 'Publicité',
        skipMessage: 'Passer la publicité',
        textForClickUIOnMobile: 'En savoir plus',
        adBlockDetectedMessage: 'Bloqueur de publicité détecté',
        adBlockMessageMessageExtended: 'Notre site utilise la publicité pour se rémunérer - merci de bien vouloir autoriser la publicité pour notre site',
        adBlockDetectedButton: 'J\'ai désactivé mon bloqueur de publicité'
      }
    };
  }

  static get german() {
    return {
      hint: {
        auto: 'Automatisch',
        play: 'Wiedergabe',
        pause: 'Pause',
        seek: 'Schieberegler für Suche',
        enterFullscreen: 'Vollbildmodus aktivieren',
        exitFullscreen: 'Vollbildmodus beenden',
        rewind: 'Zurückspulen',
        forward: 'Nach vorne',
        sharing: 'Teilen',
        sharingLink: 'Link zum Video',
        sharingEmbedCode: 'Video teilen',
        quality: 'Qualität',
        volume: 'Lautstärke',
        mute: 'Stummschalten',
        unmute: 'Stummschaltung aufheben',
        minus: 'Minus',
        plus: 'Plus',
        speed: 'Geschwindigkeit',
        captions: 'Untertitel',
        track: 'Spur',
        transcript: 'Transkript',
        audio: 'Audiosprache',
        chapters: 'Kapitel',
        live: 'LIVE',
        close: 'Zurück',
        floating: 'schließen',
        settings: 'Einstellungen',
        back: 'Zurück',
        playlist: 'Playlist',
        next: 'Nächste',
        previous: 'Vorherige',
        related: 'Ähnliche Inhalte',
        upNext: 'Nächste',
        up: 'Oben',
        down: 'Nach unten',
        left: 'Links',
        right: 'Rechts',
        default: 'Zurücksetzen',
        off: 'Aus',
        loop: 'Schleife',
        theater: 'Theatermodus',
        info: 'Information',
        keyboardShortcut: 'Tastaturkürzel'
      },
      fccCaptions: {
        fontColor: 'Schriftfarbe',
        fontOpacity: 'Schriftopazität',
        fontSize: 'Schriftgröße',
        fontFamily: 'Schriftfamilie',
        fontEdge: 'Schriftkante',
        backgroundColor: 'Hintergrundfarbe',
        backgroundOpacity: 'Hintergrundopazität',
        windowColor: 'Fensterfarbe',
        windowOpacity: 'Fensteropazität'
      },
      error: {
        error: 'Fehler',
        customErrorMessage: 'Dieser Inhalt ist zurzeit nicht erreichbar',
        noSupportMessage: 'Dieser Inhalt kann auf diesem Gerät nicht wiedergegeben werden',
        noSupportInstallChrome: 'Mithilfe der neuesten Version von Google Chrome können Sie diesen Inhalt möglicherweise anzeigen'
      },
      ads: {
        controlBarCustomMessage: 'Werbung',
        skipMessage: 'Werbung überspringen',
        textForClickUIOnMobile: 'Mehr erfahren',
        adBlockDetectedMessage: 'AdBlock erkannt',
        adBlockMessageMessageExtended: 'Unsere Website muss unseren Zuschauern Werbung zeigen - Bitte erlauben Sie Werbung auf unserer Website',
        adBlockDetectedButton: 'Ich habe AdBlock deaktiviert'
      }
    };
  }

  static get greek() {
    return {
      hint: {
        auto: 'Αυτόματο',
        play: 'Παίζω',
        pause: 'Παύση',
        seek: 'Ψάχνω',
        enterFullscreen: 'Μπείτε σε πλήρη οθόνη',
        exitFullscreen: 'Έξοδος από πλήρη οθόνη',
        rewind: 'Πίσω',
        forward: 'Προς τα εμπρός',
        sharing: 'Μερίδιο',
        sharingLink: 'Σύνδεσμος στο βίντεο',
        sharingEmbedCode: 'Ενσωμάτωση βίντεο',
        quality: 'Ποιότητα',
        volume: 'Ενταση ΗΧΟΥ',
        mute: 'Βουβός',
        unmute: 'χωρίς σίγαση',
        minus: 'Μείον',
        plus: 'Συν',
        speed: 'Ταχύτητα',
        captions: 'Κλειστές λεζάντες',
        track: 'Πίστα',
        transcript: 'Αντίγραφο',
        audio: 'Γλώσσες ήχου',
        chapters: 'Κεφάλαια',
        live: 'Ζωντανά',
        close: 'Κλείσε',
        floating: 'Κλείσε',
        settings: 'Ρυθμίσεις',
        back: 'Πίσω',
        playlist: 'Playlist',
        next: 'Επόμενο',
        previous: 'Προηγούμενος',
        related: 'Σχετίζεται με',
        upNext: 'Επόμενο',
        up: 'Πάνω',
        down: 'Κάτω',
        left: 'Αριστερά',
        right: 'σωστά',
        default: 'Προκαθορισμένο',
        off: 'Μακριά από',
        loop: 'Βρόχος',
        theater: 'Λειτουργία θεάτρου',
        info: 'Πληροφορίες',
        keyboardShortcut: 'Συντόμευση πληκτρολογίου'
      },
      fccCaptions: {
        fontColor: 'Χρώμα γραμματοσειράς',
        fontOpacity: 'Αδιαφάνεια γραμματοσειράς',
        fontSize: 'Μέγεθος γραμματοσειράς',
        fontFamily: 'Οικογένεια γραμματοσειρών',
        fontEdge: 'Άκρη γραμματοσειράς',
        backgroundColor: 'Χρώμα του φόντου',
        backgroundOpacity: 'Αδιαφάνεια φόντου',
        windowColor: 'Χρώμα παραθύρου',
        windowOpacity: 'Αδιαφάνεια παραθύρου'
      },
      error: {
        error: 'Λάθος',
        customErrorMessage: 'Αυτό το περιεχόμενο είναι προσωρινά μη διαθέσιμο',
        noSupportMessage: 'Δεν είναι δυνατή η αναπαραγωγή αυτού του περιεχομένου σε αυτήν τη συσκευή',
        noSupportInstallChrome: 'Η χρήση της πιο πρόσφατης έκδοσης του Google Chrome μπορεί να βοηθήσει στην προβολή αυτού του περιεχομένου'
      },
      ads: {
        controlBarCustomMessage: 'διαφήμιση',
        skipMessage: 'Skip ad',
        textForClickUIOnMobile: 'Παράλειψη διαφήμισης',
        adBlockDetectedMessage: 'Εντοπίστηκε AdBlock',
        adBlockMessageMessageExtended: 'Ο ιστότοπός μας πρέπει να εμφανίζει διαφημίσεις στους θεατές μας - επιτρέψτε τις διαφημίσεις στον ιστότοπό μας',
        adBlockDetectedButton: 'Έχω απενεργοποιήσει το AdBlock'
      }
    };
  }

  static get hebrew() {
    return {
      hint: {
        auto: 'אוטומטי',
        play: 'נגן',
        pause: 'השהה',
        seek: 'חפש',
        enterFullscreen: 'היכנס למסך מלא',
        exitFullscreen: 'יציאה ממסך מלא',
        rewind: 'להריץ לאחור',
        forward: 'קָדִימָה',
        sharing: 'שיתוף',
        sharingLink: 'קישור לסרטון',
        sharingEmbedCode: 'הטמעת סרטון',
        quality: 'איכות',
        volume: 'עוצמת קול',
        mute: 'השתקה',
        unmute: 'ביטול השתקה',
        minus: 'פחות',
        plus: 'יותר',
        speed: 'מהירות',
        captions: 'כתוביות',
        track: 'מַסלוּל',
        transcript: 'תעתיק',
        audio: 'שפות אודיו',
        chapters: 'פרקים',
        live: 'LIVE',
        close: 'סגור',
        floating: 'סגור',
        settings: 'הגדרות',
        back: 'חזור',
        playlist: 'Playlist',
        next: 'הַבָּא',
        previous: 'הקודם',
        related: 'קשור',
        upNext: 'הַבָּא',
        up: 'למעלה',
        down: 'מטה',
        left: 'שמאלה',
        right: 'ימין',
        default: 'לאפס',
        off: 'כבוי',
        loop: 'לוּלָאָה',
        theater: 'מצב תיאטרון',
        info: 'מֵידָע',
        keyboardShortcut: 'קיצור מקלדת'
      },
      fccCaptions: {
        fontColor: 'צבע גופן',
        fontOpacity: 'אטימות גופנים',
        fontSize: 'גודל גופן',
        fontFamily: 'משפחת גופן',
        fontEdge: 'קצה הגופן',
        backgroundColor: 'צבע רקע',
        backgroundOpacity: 'אטימות רקע',
        windowColor: 'צבע חלון',
        windowOpacity: 'אטימות חלונות'
      },
      error: {
        error: 'שְׁגִיאָה',
        customErrorMessage: 'תוכן זה אינו זמין כרגע',
        noSupportMessage: 'לא ניתן לנגן תוכן זה על התקן זה',
        noSupportInstallChrome: 'שימוש בגרסה העדכנית ביותר של Google Chrome יכולה לעזור לצפות בתוכן זה'
      },
      ads: {
        controlBarCustomMessage: 'פרסומת',
        skipMessage: 'דלג על הפרסומת',
        textForClickUIOnMobile: 'מידע נוסף',
        adBlockDetectedMessage: 'זוהה AdBlock',
        adBlockMessageMessageExtended: 'האתר שלנו צריך להציג פרסומת לצופים שלנו - אנא אפשר פרסומות באתר שלנו',
        adBlockDetectedButton: 'השבתתי את AdBlock'
      }
    };
  }

  static get spanish() {
    return {
      hint: {
        auto: 'Auto',
        play: 'Botón de reproducción',
        pause: 'Pausa',
        seek: 'Barra deslizante de búsqueda',
        enterFullscreen: 'Ingrese a pantalla completa',
        exitFullscreen: 'Salir del modo de pantalla completa',
        rewind: 'Rebobinar',
        forward: 'Avanzar',
        sharing: 'Compartir',
        sharingLink: 'Enlace al video',
        sharingEmbedCode: 'Compartir video',
        quality: 'Calidad',
        volume: 'Volumen',
        mute: 'Silenciar',
        unmute: 'Activar sonido',
        minus: 'Menos',
        plus: 'Más',
        speed: 'Velocidad',
        captions: 'Subtítulos',
        track: 'Pista',
        transcript: 'Transcripción',
        audio: 'Idiomas',
        chapters: 'Capítulos',
        live: 'EN DIRECTO',
        close: 'Atrás',
        floating: 'Atrás',
        settings: 'Configuraciones',
        back: 'Atrás',
        playlist: 'Playlist',
        next: 'Siguiente',
        previous: 'Anterior',
        related: 'Relacionados',
        upNext: 'Siguiente',
        up: 'Arriba',
        down: 'Abajo',
        left: 'Izquierda',
        right: 'Derecha',
        default: 'Reajustar',
        off: 'Desactivado',
        loop: 'Círculo',
        theater: 'Modo Teatro',
        info: 'Información',
        keyboardShortcut: 'Atajo de teclado'
      },
      fccCaptions: {
        fontColor: 'Color de fuente',
        fontOpacity: 'Opacidad de fuente',
        fontSize: 'Tamaño de fuente',
        fontFamily: 'Familia tipográfica',
        fontEdge: 'Borde de fuente',
        backgroundColor: 'Color de fondo',
        backgroundOpacity: 'Opacidad de fondo',
        windowColor: 'Color de ventana',
        windowOpacity: 'Opacidad de la ventana'
      },
      error: {
        error: 'Error',
        customErrorMessage: 'Contenido no disponible actualmente',
        noSupportMessage: 'Este contenido no se puede reproducir en este dispositivo',
        noSupportInstallChrome: 'Usar la última versión de Google Chrome puede ayudar a ver este contenido'
      },
      ads: {
        controlBarCustomMessage: 'Publicidad',
        skipMessage: 'Saltar publicidad',
        textForClickUIOnMobile: 'Saber más',
        adBlockDetectedMessage: 'AdBlock detectado',
        adBlockMessageMessageExtended: 'Nuestro sitio web necesita mostrar publicidad a nuestros visitantes. Permita la publicidad en nuestro sitio web.',
        adBlockDetectedButton: 'He desactivado AdBlock'
      }
    };
  }

  static get swahili() {
    return {
      hint: {
        auto: 'Otomatiki',
        play: 'Kucheza',
        pause: 'Sitisha',
        seek: 'Tafuta',
        enterFullscreen: 'Ingiza skrini nzima',
        exitFullscreen: 'Ondoka kwenye skrini nzima',
        rewind: 'Rudisha nyuma',
        forward: 'Mbele',
        sharing: 'Shiriki',
        sharingLink: 'Unganisha kwa video',
        sharingEmbedCode: 'Pachika video',
        quality: 'Ubora',
        volume: 'Kiasi',
        mute: 'Nyamazisha',
        unmute: 'Umerejeshwa',
        minus: 'Ondoa',
        plus: 'Pamoja',
        speed: 'Kasi',
        captions: 'Manukuu yaliyofungwa',
        track: 'Wimbo',
        transcript: 'Nakala',
        audio: 'Lugha za sauti',
        chapters: 'Sura',
        live: 'LIVE',
        close: 'Funga',
        floating: 'Funga',
        settings: 'Mipangilio',
        back: 'Nyuma',
        playlist: 'Playlist',
        next: 'Inayofuata',
        previous: 'Iliyotangulia',
        related: 'Kuhusiana',
        upNext: 'Inayofuata',
        up: 'Juu',
        down: 'Chini',
        left: 'Kushoto',
        right: 'Haki',
        default: 'Chaguomsingi',
        off: 'Imezimwa',
        loop: 'Kitanzi',
        theater: 'Hali ya ukumbi wa michezo',
        info: 'Habari',
        keyboardShortcut: 'Njia ya mkato ya kibodi'
      },
      fccCaptions: {
        fontColor: 'Rangi ya herufi',
        fontOpacity: 'Uwazi wa fonti',
        fontSize: 'Ukubwa wa herufi',
        fontFamily: 'Familia ya herufi',
        fontEdge: 'Ukingo wa fonti',
        backgroundColor: 'Rangi ya usuli',
        backgroundOpacity: 'Ufinyu wa mandharinyuma',
        windowColor: 'Rangi ya dirisha',
        windowOpacity: 'Uwazi wa dirisha'
      },
      error: {
        error: 'Hitilafu',
        customErrorMessage: 'Maudhui haya hayapatikani kwa sasa',
        noSupportMessage: 'Maudhui haya hayawezi kuchezwa kwenye kifaa hiki',
        noSupportInstallChrome: 'Kutumia toleo jipya zaidi la Google Chrome kunaweza kusaidia kutazama maudhui haya'
      },
      ads: {
        controlBarCustomMessage: 'Tangazo',
        skipMessage: 'Ruka tangazo',
        textForClickUIOnMobile: 'Jifunze zaidi',
        adBlockDetectedMessage: 'AdBlock imetambuliwa',
        adBlockMessageMessageExtended: 'Tovuti yetu inahitaji kuonyesha tangazo kwa watazamaji wetu - tafadhali ruhusu matangazo kwenye tovuti yetu',
        adBlockDetectedButton: 'Nimezima AdBlock'
      }
    };
  }

  static get portuguese() {
    return {
      hint: {
        auto: 'Auto',
        play: 'Reproduzir',
        pause: 'Pausa',
        seek: 'Botão deslizante de busca',
        enterFullscreen: 'Entrar em tela cheia',
        exitFullscreen: 'Sair do ecrã inteiro',
        rewind: 'Retroceder',
        forward: 'Enviar',
        sharing: 'Partilhar',
        sharingLink: 'Link para vídeo',
        sharingEmbedCode: 'Compartilhar vídeo',
        quality: 'Qualidade',
        volume: 'Volume',
        mute: 'Desativar som',
        unmute: 'Ativar som',
        minus: 'Menos',
        plus: 'Mais',
        speed: 'Velocidade',
        captions: 'Legendas ocultas',
        track: 'Acompanhar',
        transcript: 'Transcrição',
        audio: 'Idiomas de áudio',
        chapters: 'Capítulos',
        live: 'EM DIRETO',
        close: 'Voltar',
        floating: 'Voltar',
        settings: 'Configurações',
        back: 'Costas',
        playlist: 'Playlist',
        next: 'Próximo',
        previous: 'Anterior',
        related: 'Relacionados',
        upNext: 'Próximo',
        up: 'Acima',
        down: 'Para baixo',
        left: 'A esquerda',
        right: 'Certa',
        default: 'Restabelecer',
        off: 'Desativado',
        loop: 'Ciclo',
        theater: 'Modo Teatro',
        info: 'Em formação',
        keyboardShortcut: 'Atalho de teclado'
      },
      fccCaptions: {
        fontColor: 'Cor da fonte',
        fontOpacity: 'Opacidade da fonte',
        fontSize: 'Tamanho da fonte',
        fontFamily: 'Família de fontes',
        fontEdge: 'Beira',
        backgroundColor: 'Cor de fundo',
        backgroundOpacity: 'Opacidade de fundo',
        windowColor: 'Cor da janela',
        windowOpacity: 'Opacidade da janela'
      },
      error: {
        error: 'Erro',
        customErrorMessage: 'Este conteúdo está neste momento indisponível',
        noSupportMessage: 'Este conteúdo não pode ser reproduzido neste dispositivo',
        noSupportInstallChrome: 'Usar a versão mais recente do Google Chrome pode ajudar a visualizar esse conteúdo'
      },
      ads: {
        controlBarCustomMessage: 'Publicidade',
        skipMessage: 'Ignorar publicidade',
        textForClickUIOnMobile: 'Saber mais',
        adBlockDetectedMessage: 'AdBlock detectado',
        adBlockMessageMessageExtended: 'Nosso site precisa mostrar propaganda aos nossos telespectadores. Por favor, permita anúncios em nosso site.',
        adBlockDetectedButton: 'Desativei o AdBlock'
      }
    };
  }

  static get romanian() {
    return {
      hint: {
        auto: 'Automat',
        play: 'Joaca',
        pause: 'Pauză',
        seek: 'Căuta',
        enterFullscreen: 'Intră pe tot ecranul',
        exitFullscreen: 'Ieșiți din ecranul complet',
        rewind: 'Derulează înapoi',
        forward: 'Redirecţiona',
        sharing: 'Acțiune',
        sharingLink: 'Link către videoclip',
        sharingEmbedCode: 'Încorporați videoclipul',
        quality: 'Calitate',
        volume: 'Volum',
        mute: 'Mut',
        unmute: 'Activat',
        minus: 'Minus',
        plus: 'Plus',
        speed: 'Viteză',
        captions: 'Subtitrări închise',
        track: 'Urmări',
        transcript: 'Transcriere',
        audio: 'Limbi audio',
        chapters: 'Capitole',
        live: 'LIVE',
        close: 'Închide',
        floating: 'Închide',
        settings: 'Setări',
        back: 'Înapoi',
        playlist: 'Playlist',
        next: 'Următorul',
        previous: 'Anterior',
        related: 'Legate de',
        upNext: 'Următorul',
        up: 'Sus',
        down: 'Jos',
        left: 'Stânga',
        right: 'Dreapta',
        default: 'Mod implicit',
        off: 'Oprit',
        loop: 'Buclă',
        theater: 'Modul teatru',
        info: 'Informație',
        keyboardShortcut: 'Comanda rapidă de la tastatură'
      },
      fccCaptions: {
        fontColor: 'Culoarea fontului',
        fontOpacity: 'Opacitatea fontului',
        fontSize: 'Marimea fontului',
        fontFamily: 'Familie de fonturi',
        fontEdge: 'Marginea fontului',
        backgroundColor: 'Culoare de fundal',
        backgroundOpacity: 'Opacitatea fundalului',
        windowColor: 'Culoarea ferestrei',
        windowOpacity: 'Opacitatea ferestrei'
      },
      error: {
        error: 'Eroare',
        customErrorMessage: 'Acest continut este momentan indisponibil',
        noSupportMessage: 'Acest conținut nu poate fi redat pe acest dispozitiv',
        noSupportInstallChrome: 'Utilizarea celei mai recente versiuni de Google Chrome poate ajuta la vizualizarea acestui conținut'
      },
      ads: {
        controlBarCustomMessage: 'Publicitate',
        skipMessage: 'Sări peste reclamă',
        textForClickUIOnMobile: 'Află mai multe',
        adBlockDetectedMessage: 'AdBlock detectat',
        adBlockMessageMessageExtended: 'Site-ul nostru trebuie să arate reclame pentru spectatorii noștri - vă rugăm să permiteți anunțuri pe site-ul nostru',
        adBlockDetectedButton: 'Am dezactivat AdBlock'
      }
    };
  }

  static get italian() {
    return {
      hint: {
        auto: 'Automatico',
        play: 'Riproduci',
        pause: 'Pausa',
        seek: 'Dispositivo di scorrimento',
        enterFullscreen: 'Entra a schermo intero',
        exitFullscreen: 'Esci dalla modalità a schermo intero',
        rewind: 'Riavvolgere',
        forward: 'Inoltrare',
        sharing: 'Condividi',
        sharingLink: 'Link al video',
        sharingEmbedCode: 'Condividi il Video',
        quality: 'Qualità',
        volume: 'Volume',
        mute: 'Disattiva audio',
        unmute: 'Riattiva audio',
        minus: 'Meno',
        plus: 'Più',
        speed: 'Velocità',
        captions: 'Sottotitoli',
        track: 'Traccia',
        transcript: 'Trascrizione',
        audio: 'Lingue audio',
        chapters: 'Capitoli',
        live: 'DAL VIVO',
        close: 'Indietro',
        floating: 'Indietro',
        settings: 'Impostazioni',
        back: 'Indietro',
        playlist: 'Playlist',
        next: 'Prossimo',
        previous: 'Precedente',
        related: 'Correlati',
        upNext: 'Prossimo',
        up: 'Su',
        down: 'Giù',
        left: 'Sinistra',
        right: 'Destra',
        default: 'Il reset',
        off: 'Disattivato',
        loop: 'Ciclo continuo',
        theater: 'Modalità teatro',
        info: 'Informazione',
        keyboardShortcut: 'Scorciatoia da tastiera'
      },
      fccCaptions: {
        fontColor: 'Colore del carattere',
        fontOpacity: 'Opacità dei caratteri',
        fontSize: 'Dimensione del font',
        fontFamily: 'Famiglia di font',
        fontEdge: 'Bordo',
        backgroundColor: 'Colore di sfondo',
        backgroundOpacity: 'Opacità dello sfondo',
        windowColor: 'Colore finestra',
        windowOpacity: 'Opacità della finestra'
      },
      error: {
        error: 'Errore',
        customErrorMessage: 'Questo contenuto al momento non è disponibile',
        noSupportMessage: 'Questo contenuto non può essere riprodotto su questo dispositivo',
        noSupportInstallChrome: 'L\'utilizzo dell\'ultima versione di Google Chrome può aiutare a visualizzare questo contenuto'
      },
      ads: {
        controlBarCustomMessage: 'Messaggio pubblicitario',
        skipMessage: 'Salta pubblicità',
        textForClickUIOnMobile: 'Per saperne di più',
        adBlockDetectedMessage: 'Rilevato AdBlock',
        adBlockMessageMessageExtended: 'Il nostro sito Web deve mostrare pubblicità ai nostri spettatori. Si prega di consentire la pubblicità sul nostro sito web.',
        adBlockDetectedButton: 'Ho disabilitato AdBlock'
      }
    };
  }

  static get russian() {
    return {
      hint: {
        auto: 'Автонастройка',
        play: 'Воспроизведение',
        pause: 'Пауза',
        seek: 'Поиск',
        enterFullscreen: 'Войти в полноэкранный режим',
        exitFullscreen: 'Выход из полноэкранного режима',
        rewind: 'перематывать',
        forward: 'пересылать',
        sharing: 'Поделиться',
        sharingLink: 'Ссылка на видео',
        sharingEmbedCode: 'Поделиться видео',
        quality: 'Качество',
        volume: 'Громкость',
        mute: 'Отключить звук',
        unmute: 'Включен звук',
        minus: 'Минус',
        plus: 'Плюс',
        speed: 'Скорость',
        captions: 'Субтитры',
        track: 'Oтслеживать',
        transcript: 'Pасшифровка',
        audio: 'Языки аудио',
        chapters: 'Главы',
        live: 'Прямой эфир',
        close: 'Назад',
        floating: 'Назад',
        settings: 'Настройки',
        back: 'Назад',
        playlist: 'Playlist',
        next: 'Следующий',
        previous: 'Назад',
        related: 'Похожее',
        upNext: 'Следующий',
        up: 'Bверх',
        down: 'Bниз',
        left: 'Oсталось',
        right: 'Право',
        default: 'Oстальные',
        off: 'Выкл',
        loop: 'петля',
        theater: 'Театральный режим',
        info: 'Информация',
        keyboardShortcut: 'Сочетание клавиш'
      },
      fccCaptions: {
        fontColor: 'Цвет шрифта',
        fontOpacity: 'Непрозрачность шрифта',
        fontSize: 'Размер шрифта',
        fontFamily: 'Семейство шрифтов',
        fontEdge: 'Край',
        backgroundColor: 'Фоновый цвет',
        backgroundOpacity: 'Прозрачность фона',
        windowColor: 'Цвет окна',
        windowOpacity: 'Непрозрачность окна'
      },
      error: {
        error: 'Ошибка',
        customErrorMessage: 'В настоящее время данный контент недоступен',
        noSupportMessage: 'Данный контент не может быть воспроизведен на используемом устройстве',
        noSupportInstallChrome: 'Для просмотра данного контента рекомендуется использование последней версии Google Chrome'
      },
      ads: {
        controlBarCustomMessage: 'Pеклама',
        skipMessage: 'Пропустить рекламу',
        textForClickUIOnMobile: 'Подробнее',
        adBlockDetectedMessage: 'Обнаружен AdBlock',
        adBlockMessageMessageExtended: 'Наш сайт должен показывать рекламу нашим зрителям. Пожалуйста, разрешите рекламу на нашем сайте.',
        adBlockDetectedButton: 'Я отключил AdBlock'
      }
    };
  }

  static get taiwanese() {
    return {
      hint: {
        auto: '自動',
        play: '播放',
        pause: '暫停',
        seek: '時間軸',
        enterFullscreen: '進入全屏',
        exitFullscreen: '結束全螢幕',
        rewind: '倒帶',
        forward: '快轉',
        sharing: '分享',
        sharingLink: '影片連結',
        sharingEmbedCode: '嵌入影片',
        quality: '畫質',
        volume: '音量',
        mute: '靜音',
        unmute: '取消靜音',
        minus: '減',
        plus: '加',
        speed: '播放速度',
        captions: '字幕',
        track: '追踪',
        transcript: '字幕',
        audio: '語言',
        chapters: '章節',
        live: '直播',
        close: '關閉',
        floating: '關閉',
        settings: '設置',
        back: '返回',
        playlist: 'Playlist',
        next: '下一個',
        previous: '上一個',
        related: '相關影片',
        upNext: '下一個',
        up: '上',
        down: '下',
        left: '左',
        right: '右',
        default: '默認',
        off: '關閉',
        loop: '循環',
        theater: '劇院模式',
        info: '詳細資訊',
        keyboardShortcut: '鍵盤快捷鍵'
      },
      fccCaptions: {
        fontColor: '字體顏色',
        fontOpacity: '字體透明度',
        fontSize: '字體大小',
        fontFamily: '字型',
        fontEdge: '字體邊緣',
        backgroundColor: '背景顏色',
        backgroundOpacity: '背景透明度',
        windowColor: '視窗顏色',
        windowOpacity: '視窗透明度'
      },
      error: {
        error: '錯誤',
        customErrorMessage: '找不到檔案',
        noSupportMessage: '無法在此裝置播放',
        noSupportInstallChrome: '請點此下載與安裝最新版本的Google Chrome來觀看'
      },
      ads: {
        controlBarCustomMessage: '廣告',
        skipMessage: '略過廣告',
        textForClickUIOnMobile: '了解更多',
        adBlockDetectedMessage: '偵測到廣告攔截',
        adBlockMessageMessageExtended: '我們的網站需要向觀眾展示廣告 - 請允許我們的網站上出現廣告',
        adBlockDetectedButton: '我已禁用廣告攔截'
      }
    };
  }

  static get dutch() {
    return {
      hint: {
        auto: 'Automatisch',
        play: 'Afspelen',
        pause: 'Pauzeren',
        seek: 'Zoekschuifbalk',
        enterFullscreen: 'Voer het volledige scherm in',
        exitFullscreen: 'Volledig scherm sluiten',
        rewind: 'Terugspoelen',
        forward: 'Doorzenden',
        sharing: 'Delen',
        sharingLink: 'Link naar video',
        sharingEmbedCode: 'Deel Video',
        quality: 'Kwaliteit',
        volume: 'Volume',
        mute: 'Dempen',
        unmute: 'Niet gedempt',
        minus: 'Min',
        plus: 'Plus',
        speed: 'Snelheid',
        captions: 'Gesloten bijschriften',
        track: 'Spoor',
        transcript: 'Vertaling',
        audio: 'Taal',
        chapters: 'Hoofdstukken',
        live: 'LIVE',
        close: 'Terug',
        floating: 'Terug',
        settings: 'Instellingen',
        back: 'Terug',
        playlist: 'Playlist',
        next: 'Volgende',
        previous: 'Voorgaand',
        related: 'Gelijkaardig',
        upNext: 'Volgende',
        up: 'Omhoog',
        down: 'Beneden',
        left: 'Links',
        right: 'Rechtsaf',
        default: 'Opnieuw instellen',
        off: 'Uit',
        loop: 'Lus',
        theater: 'Theatermodus',
        info: 'Informatie',
        keyboardShortcut: 'Toetsenbord sneltoets'
      },
      fccCaptions: {
        fontColor: 'Letterkleur',
        fontOpacity: 'Ondoorzichtigheid',
        fontSize: 'Lettertypegrootte',
        fontFamily: 'Lettertypefamilie',
        fontEdge: 'Rand',
        backgroundColor: 'Achtergrond kleur',
        backgroundOpacity: 'Achtergronddekking',
        windowColor: 'Venster kleur',
        windowOpacity: 'Venster ondoorzichtigheid'
      },
      error: {
        error: 'Fout',
        customErrorMessage: 'Deze inhoud is momenteel niet beschikbaar',
        noSupportMessage: 'Deze inhoud kan niet op dit apparaat worden afgespeeld',
        noSupportInstallChrome: 'Het gebruik van de nieuwste versie van Google Chrome kan helpen om deze inhoud te bekijken'
      },
      ads: {
        controlBarCustomMessage: 'Advertentie',
        skipMessage: 'Advertentie overslaan',
        textForClickUIOnMobile: 'Kom meer te weten',
        adBlockDetectedMessage: 'AdBlock gedetecteerd',
        adBlockMessageMessageExtended: 'Onze website moet advertenties aan onze kijkers tonen - sta advertenties op onze website toe',
        adBlockDetectedButton: 'Ik heb AdBlock uitgeschakeld'
      }
    };
  }

  static get polish() {
    return {
      hint: {
        auto: 'Automatyczny',
        play: 'Odtwarzaj',
        pause: 'Zatrzymaj',
        seek: 'Suwak przewijania',
        enterFullscreen: 'Wejdź na pełny ekran',
        exitFullscreen: 'Zamknij pełny ekran',
        rewind: 'Przewijać',
        forward: 'Popierać',
        sharing: 'Udostępnij',
        sharingLink: 'Link do wideo',
        sharingEmbedCode: 'Udostępnij film',
        quality: 'Jakość',
        volume: 'Głośność',
        mute: 'Wycisz',
        unmute: 'Wyłącz wyciszenie',
        minus: 'Minus',
        plus: 'Plus',
        speed: 'Prędkość',
        captions: 'Zamknięte napisy',
        track: 'Tor',
        transcript: 'Transkrypcja',
        audio: 'Język',
        chapters: 'Odcinki',
        live: 'Na żywo',
        close: 'Wstecz',
        floating: 'Wstecz',
        settings: 'Ustawienia',
        back: 'Z powrotem',
        playlist: 'Playlist',
        next: 'Następny',
        previous: 'Poprzedni',
        related: 'Treści powiązane',
        upNext: 'Następny',
        up: 'W górę',
        down: 'Na dół',
        left: 'Lewo',
        right: 'Dobrze',
        default: 'Resetowanie',
        off: 'Wyłączone',
        loop: 'Pętla',
        theater: 'Tryb teatralny',
        info: 'Informacja',
        keyboardShortcut: 'Skrót klawiszowy'
      },
      fccCaptions: {
        fontColor: 'Kolor czcionki',
        fontOpacity: 'Krycie czcionki',
        fontSize: 'Rozmiar czcionki',
        fontFamily: 'Rodzina czcionek',
        fontEdge: 'Krawędź',
        backgroundColor: 'Kolor tła',
        backgroundOpacity: 'Krycie tła',
        windowColor: 'Kolor okna',
        windowOpacity: 'Krycie okna'
      },
      error: {
        error: 'Błąd',
        customErrorMessage: 'Ta treść jest aktualnie niedostępna',
        noSupportMessage: 'Tej treści nie można odtworzyć na tym urządzeniu',
        noSupportInstallChrome: 'Aby wyświetlić tę treść, użyj najnowszej wersji Google Chrome'
      },
      ads: {
        controlBarCustomMessage: 'Reklama',
        skipMessage: 'Pomiń reklamę',
        textForClickUIOnMobile: 'Więcej informacji',
        adBlockDetectedMessage: 'Wykryto AdBlocka',
        adBlockMessageMessageExtended: 'Nasza witryna internetowa musi wyświetlać reklamy naszym widzom - prosimy o zezwolenie na reklamę na naszej stronie internetowej',
        adBlockDetectedButton: 'Wyłączyłem AdBlocka'
      }
    };
  }

  static get japanese() {
    return {
      hint: {
        auto: '自動',
        play: '再生',
        pause: '一時停止',
        seek: 'シーク バー',
        enterFullscreen: 'フルスクリーンに入る',
        exitFullscreen: '全画面モードの終了',
        rewind: '巻き戻し',
        forward: '回す',
        sharing: '共有',
        sharingLink: 'ビデオへのリンク',
        sharingEmbedCode: '動画をシェアする',
        quality: '画質・音質',
        volume: '音量',
        mute: 'ミュート',
        unmute: 'ミュート解除',
        minus: 'マイナス',
        plus: 'プラス',
        speed: '再生速度',
        captions: '字幕',
        track: '追跡',
        transcript: '筆記録',
        audio: '言語',
        chapters: 'チャプター',
        live: 'ライブ',
        close: '戻る',
        floating: '戻る',
        settings: '設定',
        back: 'バック',
        playlist: 'Playlist',
        next: '次',
        previous: '前',
        related: '関連コンテンツ',
        upNext: '次',
        up: 'アップ',
        down: 'ダウン',
        left: '左',
        right: '正しい',
        default: 'リセットする',
        off: 'オフ',
        loop: 'ループ',
        theater: 'シアターモード',
        info: '情報',
        keyboardShortcut: 'キーボード ショートカット'
      },
      fccCaptions: {
        fontColor: 'フォントカラー',
        fontOpacity: 'フォントの不透明度',
        fontSize: 'フォントサイズ',
        fontFamily: 'フォントファミリー',
        fontEdge: '縁',
        backgroundColor: '背景色',
        backgroundOpacity: '背景の不透明度',
        windowColor: 'ウィンドウの色',
        windowOpacity: 'ウィンドウの不透明度'
      },
      error: {
        error: 'エラー',
        customErrorMessage: 'このコンテンツは現在利用できません',
        noSupportMessage: 'このコンテンツは、このデバイスでは再生できません',
        noSupportInstallChrome: 'Google Chromeの最新版を使用すると、このコンテンツを視聴できます'
      },
      ads: {
        controlBarCustomMessage: '広告',
        skipMessage: '広告をスキップ',
        textForClickUIOnMobile: '詳細はこちら',
        adBlockDetectedMessage: 'AdBlock が検出されました',
        adBlockMessageMessageExtended: '私たちのウェブサイトは閲覧者に広告を表示する必要があります - 私たちのウェブサイトでの広告を許可してください',
        adBlockDetectedButton: 'AdBlock を無効にしました'
      }
    };
  }

  static get chinese() {
    return {
      hint: {
        auto: '自动',
        play: '播放',
        pause: '暂停',
        seek: '定位',
        enterFullscreen: '进入全屏',
        exitFullscreen: '退出全屏',
        rewind: '倒带',
        forward: '发送',
        sharing: '共享',
        sharingLink: '链接到视频',
        sharingEmbedCode: '嵌入视频',
        quality: '分辨率',
        volume: '音量',
        mute: '静音',
        unmute: '取消静音',
        minus: '减少',
        plus: '增加',
        speed: '速度',
        captions: '字幕',
        track: '追踪',
        transcript: '成绩单',
        audio: '音频语言',
        chapters: '章节',
        live: '直播',
        close: '返回',
        floating: '返回',
        settings: '设定值',
        back: '背部',
        playlist: 'Playlist',
        next: '下一个',
        previous: '上一个',
        related: '相关',
        upNext: '即将播放',
        up: '上',
        down: '下',
        left: '剩下',
        right: '对',
        default: '重启',
        off: '关闭',
        loop: '环形',
        theater: '剧院模式',
        info: '信息',
        keyboardShortcut: '键盘快捷键'
      },
      fccCaptions: {
        fontColor: '字体颜色',
        fontOpacity: '字体不透明度',
        fontSize: '字体大小',
        fontFamily: '字体系列',
        fontEdge: '边缘',
        backgroundColor: '背景颜色',
        backgroundOpacity: '背景不透明度',
        windowColor: '窗户颜色',
        windowOpacity: '窗口不透明度'
      },
      error: {
        error: '错误',
        customErrorMessage: '此内容当前不可用',
        noSupportMessage: '无法在此设备上播放此内容',
        noSupportInstallChrome: '使用最新版本的 Google Chrome 可能有助于观看此内容'
      },
      ads: {
        controlBarCustomMessage: '广告',
        skipMessage: '跳过广告',
        textForClickUIOnMobile: '了解更多详情',
        adBlockDetectedMessage: '检测到广告拦截',
        adBlockMessageMessageExtended: '我们的网站需要向观众展示广告 - 请允许我们的网站上出现广告',
        adBlockDetectedButton: '我已禁用广告拦截'
      }
    };
  }

  static get korean() {
    return {
      hint: {
        auto: '자동',
        play: '재생',
        pause: '일시정지',
        seek: '탐색',
        enterFullscreen: '전체 화면 입력',
        exitFullscreen: '전체화면 종료',
        rewind: '되감기',
        forward: '전송하다',
        sharing: '공유하기',
        sharingLink: '동영상 링크',
        sharingEmbedCode: '동영상 퍼가기',
        quality: '품질',
        volume: '음량',
        mute: '음소거',
        unmute: '음소거 해제',
        minus: '작게',
        plus: '크게',
        speed: '재생속도',
        captions: '자막',
        track: '과정',
        transcript: '성적 증명서',
        audio: '오디오 언어',
        chapters: '챕터',
        live: 'LIVE',
        close: '닫기',
        floating: '닫기',
        settings: '설정',
        back: '뒤',
        playlist: 'Playlist',
        next: '다음',
        previous: '이전',
        related: '관련 콘텐츠',
        upNext: '다음 콘텐츠',
        up: '쪽으로',
        down: '내려가는',
        left: '왼쪽',
        right: '권리',
        default: '초기화',
        off: '끄기',
        loop: '고리',
        theater: '극장 모드',
        info: '정보',
        keyboardShortcut: '키보드 단축키'
      },
      fccCaptions: {
        fontColor: '글자 색',
        fontOpacity: '글꼴 불투명도',
        fontSize: '글꼴 크기',
        fontFamily: '글꼴 군',
        fontEdge: '가장자리',
        backgroundColor: '배경색',
        backgroundOpacity: '배경 불투명도',
        windowColor: '창 색상',
        windowOpacity: '창 불투명도'
      },
      error: {
        error: '오류',
        customErrorMessage: '현재 이용할 수 없는 콘텐츠입니다',
        noSupportMessage: '이 기기에서 재생되지 않는 콘텐츠입니다',
        noSupportInstallChrome: '최신 버전의 Google Chrome을 사용하면 이 콘텐츠 시청에 도움이 될 것입니다'
      },
      ads: {
        controlBarCustomMessage: '광고',
        skipMessage: '광고 건너뛰기',
        textForClickUIOnMobile: '자세히 알아보기',
        adBlockDetectedMessage: 'AdBlock이 감지되었습니다.',
        adBlockMessageMessageExtended: '우리 웹사이트는 시청자에게 광고를 표시해야 합니다. 당사 웹사이트에 광고를 허용해 주세요.',
        adBlockDetectedButton: 'AdBlock을 비활성화했습니다'
      }
    };
  }

  static get swedish() {
    return {
      hint: {
        auto: 'Automatisk',
        play: 'Spela',
        pause: 'Pausa',
        seek: 'Sök',
        enterFullscreen: 'Öppna helskärm',
        exitFullscreen: 'Gå ur fullskärm',
        rewind: 'Spola tillbaka',
        forward: 'Vidarebefordra',
        sharing: 'Dela',
        sharingLink: 'Länk till video',
        sharingEmbedCode: 'Bädda in video',
        quality: 'Kvalitet',
        volume: 'Volym',
        mute: 'Ljud av',
        unmute: 'Ljud på',
        minus: 'Minus',
        plus: 'Plus',
        speed: 'Hastighet',
        captions: 'Undertexter',
        track: 'Spår',
        transcript: 'Transkript',
        audio: 'Ljudspråk',
        chapters: 'Kapitel',
        live: 'LIVE',
        close: 'Stäng',
        floating: 'Stäng',
        settings: 'Inställningar',
        back: 'Tillbaka',
        playlist: 'Playlist',
        next: 'Nästa',
        previous: 'Föregående',
        related: 'Relaterat',
        upNext: 'Nästa',
        up: 'Upp',
        down: 'Ner',
        left: 'Vänster',
        right: 'Rätt',
        default: 'Återställa',
        off: 'Av',
        loop: 'Slinga',
        theater: 'Teaterläge',
        info: 'Information',
        keyboardShortcut: 'Tangentbordsgenväg'
      },
      fccCaptions: {
        fontColor: 'Fontfärg',
        fontOpacity: 'Typ av teckensnitt',
        fontSize: 'Textstorlek',
        fontFamily: 'Typsnittsfamilj',
        fontEdge: 'Kant',
        backgroundColor: 'Bakgrundsfärg',
        backgroundOpacity: 'Bakgrundens opacitet',
        windowColor: 'Fönsterfärg',
        windowOpacity: 'Fönster Opacitet'
      },
      error: {
        error: 'Fel',
        customErrorMessage: 'Detta innehåll är för tillfället inte tillgängligt',
        noSupportMessage: 'Detta innehåll kan inte spelas upp på denna enhet',
        noSupportInstallChrome: 'Att använda senaste versionen av Google Chrome kan möjligen underlätta att se detta innehåll'
      },
      ads: {
        controlBarCustomMessage: 'Annons',
        skipMessage: 'Hoppa över annons',
        textForClickUIOnMobile: 'Läs mer',
        adBlockDetectedMessage: 'AdBlock upptäcktes',
        adBlockMessageMessageExtended: 'Vår webbplats måste visa reklam för våra tittare - vänligen tillåt annonser på vår webbplats',
        adBlockDetectedButton: 'Jag har inaktiverat AdBlock'
      }
    };
  }

  static get thai() {
    return {
      hint: {
        auto: 'อัตโนมัติ',
        play: 'เล่น',
        pause: 'หยุดชั่วคราว',
        seek: 'แถบเลื่อนค้นหา',
        enterFullscreen: 'เข้าสู่แบบเต็มหน้าจอ',
        exitFullscreen: 'ออกจากโหมดเต็มหน้าจอ',
        rewind: 'ย้อนกลับ',
        forward: 'ล่วงหน้า',
        sharing: 'แชร์',
        sharingLink: 'ลิงก์ไปยังวิดีโอ',
        sharingEmbedCode: 'คัดลอกโค้ดเพื่อนำวิดีโอไปแสดงโชว์ที่อื่น',
        quality: 'ความละเอียด',
        volume: 'ระดับเสียง',
        mute: 'ปิดเสียง',
        unmute: 'เปิดเสียง',
        minus: 'ลด',
        plus: 'เพิ่ม',
        speed: 'อัตราความเร็วในการเล่น',
        captions: 'คำอธิบายวิดีโอ',
        track: 'ติดตาม',
        transcript: 'สำเนา',
        audio: 'ภาษาเสียง',
        chapters: 'ตอน',
        live: 'LIVE',
        close: 'ปิด',
        floating: 'ปิด',
        settings: 'การตั้งค่า',
        back: 'กลับ',
        playlist: 'Playlist',
        next: 'ต่อไป',
        previous: 'ก่อนหน้า',
        related: 'เนื้อหาที่เกี่ยวข้อง',
        upNext: 'ต่อไป',
        up: 'ขึ้น',
        down: 'ลง',
        left: 'ซ้าย',
        right: 'ขวา',
        default: 'รีเซ็ต',
        off: 'ปิด',
        loop: 'ห่วง',
        theater: 'โหมดโรงละคร',
        info: 'ข้อมูล',
        keyboardShortcut: 'แป้นพิมพ์ลัด'
      },
      fccCaptions: {
        fontColor: 'สีตัวอักษร',
        fontOpacity: 'ความทึบของตัวอักษร',
        fontSize: 'ขนาดตัวอักษร',
        fontFamily: 'ตระกูลฟอนต์',
        fontEdge: 'ขอบ',
        backgroundColor: 'สีพื้นหลัง',
        backgroundOpacity: 'ความทึบของพื้นหลัง',
        windowColor: 'สีหน้าต่าง',
        windowOpacity: 'ความทึบของหน้าต่าง'
      },
      error: {
        error: 'ข้อผิดพลาด',
        customErrorMessage: 'ไม่สามารถแสดงเนื้อหาได้ในขณะนี้',
        noSupportMessage: 'ไม่สามารถแสดงเนื้อหาได้บนอุปกรณ์เครื่องนี้',
        noSupportInstallChrome: 'การใช้ Google Chrome เวอร์ชันล่าสุดช่วยให้คุณสามารถดูเนื้อหานี้ได้'
      },
      ads: {
        controlBarCustomMessage: 'โฆษณา',
        skipMessage: 'ข้ามโฆษณา',
        textForClickUIOnMobile: 'ดูเพิ่มเติม',
        adBlockDetectedMessage: 'ตรวจพบ AdBlock',
        adBlockMessageMessageExtended: 'เว็บไซต์ของเราจำเป็นต้องแสดงโฆษณาต่อผู้ชม - โปรดอนุญาตโฆษณาบนเว็บไซต์ของเรา',
        adBlockDetectedButton: 'ฉันได้ปิดการใช้งาน AdBlock แล้ว'
      }
    };
  }

  static get turkish() {
    return {
      hint: {
        auto: 'Otomatik',
        play: 'Oynat',
        pause: 'Duraklat',
        seek: 'Arama kaydırma çubuğu',
        enterFullscreen: 'Tam ekran yap',
        exitFullscreen: 'Tam ekrandan çık',
        rewind: 'Yeniden sarmak',
        forward: 'Ilerletmek',
        sharing: 'Paylaş',
        sharingLink: 'Video bağlantısı',
        sharingEmbedCode: 'Videoyu göm',
        quality: 'Çözünürlük',
        volume: 'Ses düzeyi',
        mute: 'Sesi kapat',
        unmute: 'Sesi aç',
        minus: 'Eksi',
        plus: 'Artı',
        speed: 'Hız',
        captions: 'Altyazılar',
        track: 'Izlemek',
        transcript: 'Transcript',
        audio: 'Ses dilleri',
        chapters: 'Bölümler',
        live: 'Canlı',
        settings: 'Ayarlar',
        back: 'Geri',
        close: 'Geri',
        floating: 'Geri',
        playlist: 'Playlist',
        next: 'Sonraki',
        previous: 'Önceki',
        related: 'İlgili',
        upNext: 'Sonraki',
        up: 'Yukarı',
        down: 'Aşağı',
        left: 'Ayrıldı',
        right: 'Sağ',
        default: 'Sıfırla',
        off: 'Kapalı',
        loop: 'Döngü',
        theater: 'Tiyatro Modu',
        info: 'Bilgi',
        keyboardShortcut: 'Klavye kısayolu'
      },
      fccCaptions: {
        fontColor: 'Yazı rengi',
        fontOpacity: 'Yazı Tipi Opaklığı',
        fontSize: 'Yazı Boyutu',
        fontFamily: 'Font ailesi',
        fontEdge: 'Kenar',
        backgroundColor: 'Arka plan rengi',
        backgroundOpacity: 'Arka Plan Şeffaflığı',
        windowColor: 'Pencere Rengi',
        windowOpacity: 'Pencere Şeffaflığı'
      },
      error: {
        error: 'Hata',
        customErrorMessage: 'Bu içerik şu anda kullanılamıyor',
        noSupportMessage: 'Bu içerik bu cihazda oynatılamıyor',
        noSupportInstallChrome: 'Google Chrome\'un en son sürümünü kullanmak bu içeriği görüntülemenize yardımcı olabilir'
      },
      ads: {
        controlBarCustomMessage: 'Reklam',
        skipMessage: 'Reklamı atla',
        textForClickUIOnMobile: 'Daha fazla bilgi',
        adBlockDetectedMessage: 'AdBlock algılandı',
        adBlockMessageMessageExtended: 'Web sitemizin izleyicilerimize reklam göstermesi gerekiyor - lütfen web sitemizde reklamlara izin verin',
        adBlockDetectedButton: 'AdBlock\'u devre dışı bıraktım'
      }
    };
  }

  static get vietnamese() {
    return {
      hint: {
        auto: 'Tự động',
        play: 'Đọc',
        pause: 'Dừng',
        seek: 'Tìm',
        enterFullscreen: 'Vào toàn màn hình',
        exitFullscreen: 'Thoát khỏi chế độ toàn màn hình',
        rewind: 'Tua lại',
        forward: 'Chuyển',
        sharing: 'Chia sẻ',
        sharingLink: 'Đường dẫn đến video',
        sharingEmbedCode: 'Gắn video',
        quality: 'Chất lượng',
        volume: 'Âm lượng',
        mute: 'Tắt tiếng',
        unmute: 'Bật tiếng',
        minus: 'Trừ',
        plus: 'Cộng',
        speed: 'Tốc độ',
        captions: 'Phụ đề chi tiết',
        track: 'Theo dõi',
        transcript: 'Bảng điểm',
        audio: 'Ngôn ngữ âm thanh',
        chapters: 'Chương',
        live: 'LIVE',
        settings: 'Cài đặt',
        back: 'Trở lại',
        close: 'Đóng',
        floating: 'Đóng',
        playlist: 'Playlist',
        next: 'Kế tiếp',
        previous: 'Trước',
        related: 'Có liên quan',
        upNext: 'Kế tiếp',
        up: 'Lên',
        down: 'Xuống',
        left: 'Trái',
        right: 'Đúng',
        default: 'Cài lại',
        off: 'Tắt',
        loop: 'Vòng',
        theater: 'Chế độ rạp hát',
        info: 'Thông tin',
        keyboardShortcut: 'Phim tăt'
      },
      fccCaptions: {
        fontColor: 'Màu chữ',
        fontOpacity: 'Độ mờ phông chữ',
        fontSize: 'Cỡ chữ',
        fontFamily: 'Họ Phông chữ',
        fontEdge: 'Cạnh',
        backgroundColor: 'Màu nền',
        backgroundOpacity: 'Độ mờ nền',
        windowColor: 'Màu cửa sổ',
        windowOpacity: 'Độ mờ cửa sổ'
      },
      error: {
        error: 'Lỗi',
        customErrorMessage: 'Nội dung này hiện không có',
        noSupportMessage: 'Nội dung này không thể đọc trên thiết bị này',
        noSupportInstallChrome: 'Sử dụng phiên bản mới nhất của Google Chrome có thể giúp xem nội dung này'
      },
      ads: {
        controlBarCustomMessage: 'Quảng cáo',
        skipMessage: 'Bỏ quảng cáo',
        textForClickUIOnMobile: 'Tìm hiểu thêm',
        adBlockDetectedMessage: 'Đã phát hiện thấy AdBlock',
        adBlockMessageMessageExtended: 'Trang web của chúng tôi cần hiển thị quảng cáo cho người xem - vui lòng cho phép quảng cáo trên trang web của chúng tôi',
        adBlockDetectedButton: 'Tôi đã tắt AdBlock'
      }
    };
  }

  static get danish() {
    return {
      hint: {
        auto: 'Automatisk',
        play: 'Afspil',
        pause: 'Pause',
        seek: 'Søg',
        enterFullscreen: 'Gå ind i fuld skærm',
        exitFullscreen: 'Annuller fuld skærm',
        rewind: 'Spole tilbage',
        forward: 'Frem',
        sharing: 'Del',
        sharingLink: 'Link til video',
        sharingEmbedCode: 'Indlejr video',
        quality: 'Kvalitet',
        volume: 'Lydstyrke',
        mute: 'Lydløs',
        unmute: 'Annuller lydløs',
        minus: 'Minus',
        plus: 'Plus',
        speed: 'Hastighed',
        captions: 'Lukkede billedtekster',
        track: 'Spore',
        transcript: 'Udskrift',
        audio: 'Lydsprog',
        chapters: 'Kapitler',
        live: 'LIVE',
        close: 'Luk',
        floating: 'Luk',
        settings: 'Indstillinger',
        back: 'Tilbage',
        playlist: 'Playlist',
        next: 'Næste',
        previous: 'Forrige',
        related: 'Relateret',
        upNext: 'Næste',
        up: 'Op',
        down: 'Ned',
        left: 'Venstre',
        right: 'Ret',
        default: 'Nulstil',
        off: 'Fra',
        loop: 'Sløjfe',
        theater: 'Teatertilstand',
        info: 'Information',
        keyboardShortcut: 'Tastaturgenvej'
      },
      fccCaptions: {
        fontColor: 'Skrift farve',
        fontOpacity: 'Skrifttæthed',
        fontSize: 'Skriftstørrelse',
        fontFamily: 'Fontfamilie',
        fontEdge: 'Kant',
        backgroundColor: 'Baggrundsfarve',
        backgroundOpacity: 'Baggrundsdensitet',
        windowColor: 'Vinduesfarve',
        windowOpacity: 'Vinduesgennemsigtighed'
      },
      error: {
        error: 'Fejl',
        customErrorMessage: 'Dette indhold er ikke tilgængeligt for øjeblikket',
        noSupportMessage: 'Dette indhold kan ikke afspilles på denne enhed',
        noSupportInstallChrome: 'Hvis du bruger den nyeste version af Google Chrome, kan det hjælpe til at få vist dette indhold'
      },
      ads: {
        controlBarCustomMessage: 'Annonce',
        skipMessage: 'Spring annonce over',
        textForClickUIOnMobile: 'Lær mere',
        adBlockDetectedMessage: 'AdBlock registreret',
        adBlockMessageMessageExtended: 'Vores hjemmeside skal vise annoncer til vores seere - tillad venligst annoncer på vores hjemmeside',
        adBlockDetectedButton: 'Jeg har deaktiveret AdBlock'
      }
    };
  }

  static get finnish() {
    return {
      hint: {
        auto: 'Automaattinen',
        play: 'Toista',
        pause: 'Keskeytä',
        seek: 'Hae',
        enterFullscreen: 'Siirry koko näyttöön',
        exitFullscreen: 'Poistu koko näytöstä',
        rewind: 'Kelaa taaksepäin',
        forward: 'Edistää',
        sharing: 'Jaa',
        sharingLink: 'Linkki videoon',
        sharingEmbedCode: 'Liitä video',
        quality: 'Laatu',
        volume: 'Äänenvoimakkuus',
        mute: 'Mykistä',
        unmute: 'Peru mykistys',
        minus: 'Miinus',
        plus: 'Plus',
        speed: 'Nopeus',
        captions: 'Tekstitys',
        track: 'Seurata',
        transcript: 'Jäljennös',
        audio: 'Audiokielet',
        chapters: 'Kappaleet',
        live: 'LIVE',
        close: 'Sulje',
        floating: 'Sulje',
        settings: 'Asetukset',
        back: 'Takaisin',
        playlist: 'Playlist',
        next: 'Seuraava',
        previous: 'Edellinen',
        related: 'Asiaan liittyvä',
        upNext: 'Seuraava',
        up: 'Ylös',
        down: 'Alas',
        left: 'Vasen',
        right: 'Oikea',
        default: 'Nollaa',
        off: 'Pois',
        loop: 'Silmukka',
        theater: 'Teatteritila',
        info: 'Tiedot',
        keyboardShortcut: 'Pikanäppäin'
      },
      fccCaptions: {
        fontColor: 'Fontin väri',
        fontOpacity: 'Fontin läpinäkyvyys',
        fontSize: 'Fonttikoko',
        fontFamily: 'Fonttiperhe',
        fontEdge: 'Reuna',
        backgroundColor: 'Taustaväri',
        backgroundOpacity: 'Taustan peittävyys',
        windowColor: 'Ikkunan väri',
        windowOpacity: 'Ikkunan peittävyys'
      },
      error: {
        error: 'Virhe',
        customErrorMessage: 'Tämä sisältö ei ole nyt käytettävissä',
        noSupportMessage: 'Sisältöä ei voi toistaa tällä laitteeella',
        noSupportInstallChrome: 'Jos käytät uusinta  Google Chrome -versiota, tämän sisällön katsominen voi olla helpompaa'
      },
      ads: {
        controlBarCustomMessage: 'Mainos',
        skipMessage: 'Jätä mainos väliin',
        textForClickUIOnMobile: 'Lisätietoja',
        adBlockDetectedMessage: 'AdBlock havaittu',
        adBlockMessageMessageExtended: 'Verkkosivustomme on näytettävä mainoksia katsojillemme - salli mainokset verkkosivustollamme',
        adBlockDetectedButton: 'Olen poistanut AdBlockin käytöstä'
      }
    };
  }

  static get norwegian() {
    return {
      hint: {
        auto: 'Automatisk',
        play: 'Spill av',
        pause: 'Pause',
        seek: 'Hopp',
        enterFullscreen: 'Gå inn i fullskjerm',
        exitFullscreen: 'Avslutt fullskjerm',
        rewind: 'Spole',
        forward: 'Framover',
        sharing: 'Del',
        sharingLink: 'Link til videoen',
        sharingEmbedCode: 'Bygg inn videoen',
        quality: 'Kvalitet',
        volume: 'Volum',
        mute: 'Kutt lyden',
        unmute: 'Slå på lyden',
        minus: 'Minus',
        plus: 'Pluss',
        speed: 'Hastighet',
        captions: 'Lukkede bildetekster',
        track: 'Spor',
        transcript: 'Transkripsjon',
        audio: 'Lydspråk',
        chapters: 'Kapitler',
        live: 'På direkten',
        close: 'Lukk',
        floating: 'Lukk',
        settings: 'Innstillinger',
        back: 'Tilbake',
        playlist: 'Playlist',
        next: 'Neste',
        previous: 'Forrige',
        related: 'Relatert',
        upNext: 'Neste',
        up: 'Opp',
        down: 'Ned',
        left: 'Venstre',
        right: 'Ikke sant',
        default: 'Nullstille',
        off: 'Av',
        loop: 'Løkke',
        theater: 'Teatermodus',
        info: 'Informasjon',
        keyboardShortcut: 'Tastatursnarvei'
      },
      fccCaptions: {
        fontColor: 'Fontin väri',
        fontOpacity: 'Fontin läpinäkyvyys',
        fontSize: 'Fonttikoko',
        fontFamily: 'Fonttiperhe',
        fontEdge: 'Reuna',
        backgroundColor: 'Taustaväri',
        backgroundOpacity: 'Taustan peittävyys',
        windowColor: 'Ikkunan väri',
        windowOpacity: 'Ikkunan peittävyys'
      },
      error: {
        error: 'Feil',
        customErrorMessage: 'Dette innholdet er for tiden ikke tilgjengelig',
        noSupportMessage: 'Dette innholdet kan ikke spilles av på denne enheten',
        noSupportInstallChrome: 'Bruk den nyeste versjonen av Google Chrome hvis du opplever problemer med å se dette innholdet'
      },
      ads: {
        controlBarCustomMessage: 'Annonse',
        skipMessage: 'Hopp over annonsen',
        textForClickUIOnMobile: 'Finn ut mer',
        adBlockDetectedMessage: 'AdBlock oppdaget',
        adBlockMessageMessageExtended: 'Nettstedet vårt må vise reklame til seerne våre - tillat annonser på nettstedet vårt',
        adBlockDetectedButton: 'Jeg har deaktivert AdBlock'
      }
    };
  }

  static get indonesian() {
    return {
      hint: {
        auto: 'Otomatis',
        play: 'Mainkan',
        pause: 'Jeda',
        seek: 'Cari',
        enterFullscreen: 'Memasuki layar penuh',
        exitFullscreen: 'Keluar layar penuh',
        rewind: 'Memutar ulang',
        forward: 'Meneruskan',
        sharing: 'Bagikan',
        sharingLink: 'Tautan ke video',
        sharingEmbedCode: 'Tempel video',
        quality: 'Kualitas',
        volume: 'Volume',
        mute: 'Bisukan',
        unmute: 'Bersuara',
        minus: 'Dikurangi',
        plus: 'Plus',
        speed: 'Kecepatan',
        captions: 'Keterangan tertutup',
        track: 'Jalur',
        transcript: 'Transkrip',
        audio: 'Bahasa audio',
        chapters: 'Bab',
        live: 'LIVE',
        close: 'Tutup',
        floating: 'Tutup',
        settings: 'Pengaturan',
        back: 'Kembali',
        playlist: 'Playlist',
        next: 'Berikutnya',
        previous: 'Sebelumnya',
        related: 'Terkait',
        upNext: 'Berikutnya',
        up: 'Naik',
        down: 'Turun',
        left: 'Kiri',
        right: 'Baik',
        default: 'Atur ulang',
        off: 'Mati',
        loop: 'Lingkaran',
        theater: 'Mode Teater',
        info: 'Informasi',
        keyboardShortcut: 'Pintasan keyboard'
      },
      fccCaptions: {
        fontColor: 'Warna huruf',
        fontOpacity: 'Opasitas Font',
        fontSize: 'Ukuran huruf',
        fontFamily: 'Keluarga Font',
        fontEdge: 'Tepi',
        backgroundColor: 'Warna latar belakang',
        backgroundOpacity: 'Opasitas Latar Belakang',
        windowColor: 'Warna Jendela',
        windowOpacity: 'Opasitas Jendela'
      },
      error: {
        error: 'Kesalahan',
        customErrorMessage: 'Saat ini konten tidak tersedia',
        noSupportMessage: 'Konten ini tidak dapat dimainkan pada perangkat',
        noSupportInstallChrome: 'Menggunakaan versi terbaru dari Google Chrome dapat membantu melihat konten ini'
      },
      ads: {
        controlBarCustomMessage: 'Iklan',
        skipMessage: 'Lewati iklan',
        textForClickUIOnMobile: 'Pelajari lebih lanjut',
        adBlockDetectedMessage: 'AdBlock terdeteksi',
        adBlockMessageMessageExtended: 'Situs web kami perlu menampilkan iklan kepada pemirsa kami - izinkan iklan di situs web kami',
        adBlockDetectedButton: 'Saya telah menonaktifkan AdBlock'
      }
    };
  }

  static get hindi() {
    return {
      hint: {
        auto: 'स्वचालित',
        play: 'चलाएँ',
        pause: 'रोकें',
        seek: 'खोजें',
        enterFullscreen: 'पूर्ण स्क्रीन दर्ज करें',
        exitFullscreen: 'फुल स्क्रीन से बाहर निकलें',
        rewind: 'रिवाइंड',
        forward: 'आगे',
        sharing: 'साझा करें',
        sharingLink: 'वीडियो से लिंक करें',
        sharingEmbedCode: 'वीडियो एम्बेड करें',
        quality: 'क्वालिटी',
        volume: 'वॉल्यूम',
        mute: 'म्यूट करें',
        unmute: 'अनम्यूट करें',
        minus: 'माइनस',
        plus: 'प्लस',
        speed: 'गति',
        captions: 'कैप्शन',
        track: 'धावन पथ',
        transcript: 'प्रतिलिपि',
        audio: 'ऑडियो भाषाएँ',
        chapters: 'चैप्टर',
        live: 'लाइव',
        close: 'बंद करें',
        floating: 'बंद करें',
        settings: 'समायोजन',
        back: 'वापस',
        playlist: 'Playlist',
        next: 'अगला',
        previous: 'पिछला',
        related: 'संबंधित',
        upNext: 'अगला',
        up: 'यूपी',
        down: 'नीचे',
        left: 'बाएं',
        right: 'सही',
        default: 'रीसेट',
        off: 'बंद',
        loop: 'कुंडली',
        theater: 'थिएटर मोड',
        info: 'जानकारी',
        keyboardShortcut: 'कुंजीपटल संक्षिप्त रीति'
      },
      fccCaptions: {
        fontColor: 'लिपि का रंग',
        fontOpacity: 'फ़ॉन्ट अपारदर्शिता',
        fontSize: 'फ़ॉन्ट आकार',
        fontFamily: 'फ़ॉन्ट परिवार',
        fontEdge: 'धार',
        backgroundColor: 'पीछे का रंग',
        backgroundOpacity: 'पृष्ठभूमि की अस्पष्टता',
        windowColor: 'खिड़की का रंग',
        windowOpacity: 'विंडो अपारदर्शिता'
      },
      error: {
        error: 'गलती',
        customErrorMessage: 'यह सामग्री फ़िलहाल अनुपलब्ध है',
        noSupportMessage: 'यह सामग्री इस डिवाइस पर नहीं चलाई जा सकती',
        noSupportInstallChrome: 'Google Chrome के नवीनतम संस्करण का इस्तेमाल करने से यह सामग्री देखने में मदद मिल सकती है'
      },
      ads: {
        controlBarCustomMessage: 'विज्ञापन',
        skipMessage: 'विज्ञापन छोड़ें',
        textForClickUIOnMobile: 'अधिक जानें',
        adBlockDetectedMessage: 'एडब्लॉक का पता चला',
        adBlockMessageMessageExtended: 'हमारी वेबसाइट को अपने दर्शकों को विज्ञापन दिखाने की आवश्यकता है - कृपया हमारी वेबसाइट पर विज्ञापनों की अनुमति दें',
        adBlockDetectedButton: 'मैंने एडब्लॉक अक्षम कर दिया है'
      }
    };
  }

  static get ukrainian() {
    return {
      hint: {
        auto: 'Автоматичний',
        play: 'грати',
        pause: 'Пауза',
        seek: 'шукати',
        enterFullscreen: 'Перейти на весь екран',
        exitFullscreen: 'Вийти з повноекранного режиму',
        rewind: 'Перемотати назад',
        forward: 'вперед',
        sharing: 'Поділіться',
        sharingLink: 'Посилання на відео',
        sharingEmbedCode: 'Вставити відео',
        quality: 'якість',
        volume: 'Обсяг',
        mute: 'Вимкнути звук',
        unmute: 'увімкни мене',
        minus: 'Мінус',
        plus: 'Плюс',
        speed: 'швидкість',
        captions: 'Закриті субтитри',
        track: 'Трек',
        transcript: 'Стенограма',
        audio: 'Мови аудіо',
        chapters: 'Розділи',
        live: 'Прямий ефір',
        close: 'Закрити',
        floating: 'Закрити',
        settings: 'Налаштування',
        back: 'Назад',
        playlist: 'Playlist',
        next: 'Далі',
        previous: 'Попередній',
        related: 'Пов\'язані',
        upNext: 'Далі',
        up: 'вгору',
        down: 'вниз',
        left: 'Ліворуч',
        right: 'правильно',
        default: 'За замовчуванням',
        off: 'Вимкнено',
        loop: 'Петля',
        theater: 'Театральний режим',
        info: 'Інформація',
        keyboardShortcut: 'Комбінація клавіш'
      },
      fccCaptions: {
        fontColor: 'Колір шрифту',
        fontOpacity: 'Непрозорість шрифту',
        fontSize: 'Розмір шрифту',
        fontFamily: 'Сімейство шрифтів',
        fontEdge: 'Край шрифту',
        backgroundColor: 'Колір фону',
        backgroundOpacity: 'Непрозорість фону',
        windowColor: 'Колір вікна',
        windowOpacity: 'Непрозорість вікна'
      },
      error: {
        error: 'Помилка',
        customErrorMessage: 'Цей вміст зараз недоступний',
        noSupportMessage: 'Цей вміст не можна відтворити на цьому пристрої',
        noSupportInstallChrome: 'Використання останньої версії Google Chrome може допомогти переглянути цей вміст'
      },
      ads: {
        controlBarCustomMessage: 'Оголошення',
        skipMessage: 'Пропустити рекламу',
        textForClickUIOnMobile: 'Вивчайте більше',
        adBlockDetectedMessage: 'Виявлено AdBlock',
        adBlockMessageMessageExtended: 'Наш веб-сайт повинен показувати рекламу нашим глядачам - дозвольте рекламу на нашому веб-сайті',
        adBlockDetectedButton: 'Я вимкнув AdBlock'
      }
    };
  }

  static get hungarian() {
    return {
      hint: {
        auto: 'Automatikus',
        play: 'Lejátszás',
        pause: 'Szünet',
        seek: 'Keresés',
        enterFullscreen: 'Lépjen be a teljes képernyőre',
        exitFullscreen: 'Kilépés teljes képernyőből',
        rewind: 'Visszatekerés',
        forward: 'Előmozdít',
        sharing: 'Megosztás',
        sharingLink: 'Hivatkozás a videóra',
        sharingEmbedCode: 'Videó beágyazása',
        quality: 'Minőség',
        volume: 'Hangerő',
        mute: 'Némítás',
        unmute: 'Némítás feloldás',
        minus: 'Mínusz',
        plus: 'Plusz',
        speed: 'Sebesség',
        captions: 'Zárt feliratok',
        track: 'Vágány',
        transcript: 'Másolat',
        audio: 'Nyelvek',
        chapters: 'Fejezetek',
        live: 'Élő',
        close: 'Bezárás',
        floating: 'Bezárás',
        settings: 'Beállítások',
        back: 'Vissza',
        playlist: 'Playlist',
        next: 'Következő',
        previous: 'Előző',
        related: 'Kapcsolódó tartalom',
        upNext: 'Következő',
        up: 'Fel',
        down: 'Le',
        left: 'Balra',
        right: 'Jobbra',
        default: 'Alapértelmezett',
        off: 'Kikapcsolva',
        loop: 'Hurok',
        theater: 'Színházi mód',
        info: 'Információ',
        keyboardShortcut: 'Billentyűparancs'
      },
      fccCaptions: {
        fontColor: 'Betű szín',
        fontOpacity: 'Betű átlátszatlansága',
        fontSize: 'Betűméret',
        fontFamily: 'Betűtípus család',
        fontEdge: 'Él',
        backgroundColor: 'Háttérszín',
        backgroundOpacity: 'Háttér átlátszatlansága',
        windowColor: 'Ablak színe',
        windowOpacity: 'Ablak átlátszatlansága'
      },
      error: {
        error: 'Hiba',
        customErrorMessage: 'A tartalom jelenleg nem elérhető',
        noSupportMessage: 'A tartalom nem lejátszható az eszközön',
        noSupportInstallChrome: 'A tartalom megtekintéséhez ajánlott a legfrisebb Google Chrome használata'
      },
      ads: {
        controlBarCustomMessage: 'Hirdetés',
        skipMessage: 'Hirdetés átugrása',
        textForClickUIOnMobile: 'Bővebben',
        adBlockDetectedMessage: 'AdBlock észlelve',
        adBlockMessageMessageExtended: 'Weboldalunknak hirdetéseket kell megjelenítenie nézőink számára - kérjük, engedélyezze a hirdetéseket webhelyünkön',
        adBlockDetectedButton: 'Letiltottam az AdBlockot'
      }
    };
  }

}
